import React from 'react';
import Translate from 'react-translate-component';
import { pick } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';
import LanguagesField from './LanguagesField';

const ApprovalPersonGeneral = ({ person : item }) => {
    const person = pick(['age', 'birthdate', 'citizenship', 'lastWorkplace', 'languages'], item);
    const { age, birthdate, citizenship, lastWorkplace, languages }  = person;

    return notEmpty(person) ? (
        <div>
            <DefinitionHeader translate='common.general' iconType='info-outline' />
            <div className='panel-view'>
                <DefinitionField translate='person.citizenship' text={ citizenship } />
                <DefinitionField translate="common.age" show={Boolean(age)}>
                    { age } ({ birthdate })
                </DefinitionField>
                <DefinitionField translate='person.lastEmployer' show={lastWorkplace.lastEmployed}>
                    { lastWorkplace.lastEmployed }
                    { " " }
                    { lastWorkplace.untilNow && <Translate content='person.untilNow' /> }
                </DefinitionField>
                <DefinitionField translate='common.languages' show={notEmpty(languages)}>
                    { <LanguagesField list={languages} /> }
                </DefinitionField>
            </div>
        </div>
    ) : null;
}

export default ApprovalPersonGeneral;
